// DEC 28 - UNUSED. REPLACED WITH USERWORKSPACESIDENAVBAR

"use client" 
import Link from "next/link";
import { useState, useEffect } from "react";
import Loading from "@/components/Atoms/Alerts/Loading";


const AdminSideNavbar =({callback}) => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [lang, setLang] = useState('en')
  const [url, setUrl] = useState({})
  const [currentNavId, setCurrentNavId] = useState(1)

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);

  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useEffect(() => {

    setLoading(false)
    // Attach a click event listener to the document
    document.addEventListener("click", closeDropdown);

    setUrl({
      pathname: window.location.pathname.split(`/${lang}/`)[1] || '',
      search: window.location.search
      });

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, [loading]);

  const handleDropdownClick = (e) => {
    // Prevent the click on the dropdown itself from triggering the closeDropdown
    e.stopPropagation();
  };

  const handleToggleClick = (e) => {
    e.stopPropagation();
    toggleDropdown();

  };

     return (
       
      <aside
      id="NavSidebar"
      className="fixed top-0 left-0 z-30 w-20 h-screen transition-transform bg-white border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700"
      aria-label="NavSidebar"
    >

      {loading && <Loading lang={'en'}/>}

      {/* bg-gradient-to-t from-violet-700 via-violet-600 to-indigo-600  */}
      <div className="h-full bg-gray-50 dark:bg-gray-900 flex flex-col justify-between">
      {/* <div className="mx-auto pt-2 text-sm text-black dark:text-white dark:hover:text-gray-500 hover:text-gray-600 duration-300"> */}
      
      {/* <Link 
            href={`/${lang === 'fr' ? `en/${url.pathname}${url.search}` : `fr/${url.pathname}${url.search}`}`}
              className={`transition duration-300 ease-in-out text-black dark:text-gray-200 flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 1 && 'bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto"><i className="fa-solid fa-globe items-center text-xl"></i><br/>
              {lang === 'fr' ? 'English' : 'Français'}</span>
            </Link> */}

      {/* <Link href={`/${lang === 'fr' ? `en/${url.pathname}${url.search}` : `fr/${url.pathname}${url.search}`}`}>
      <span className="text-center mx-auto"><i className="fa-solid fa-globe items-center text-xl"></i><br/>{lang === 'fr' ? 'English' : 'Français'}</span>
        </Link> */}
      {/* </div> */}
      
        <div className="flex flex-col justify-center">

        </div>



        <ul>



<div className="text-black dark:text-gray-200">








            <Link 
              onClick={()=>{setCurrentNavId(1); setLoading(true)}}
              href={`/admin`}
              className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 1 && 'bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto">
                <i className="fa-solid fa-table-columns items-center text-xl"></i><br/>
                {lang === 'fr' ? 'Console' : 'Dashboard'}
              </span>
            </Link>

            <Link 
            onClick={()=>{callback({tagsModalOpen:true})}}
            href={`#`}
            className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 py-2`}>
              <span className="text-center mx-auto"><i className="fa-solid fa-tag text-xl"></i><br/>
              Tags
              </span>
            </Link>


            <Link 
              onClick={()=>{setCurrentNavId(2); setLoading(true)}}
              href={`/admin/organizations`}
              className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 2 && 'bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto">
                <i className="fa-solid fa-shop items-center text-xl"></i><br/>
                Orgs
              </span>
            </Link>

            <Link 
              onClick={()=>{setCurrentNavId(3); setLoading(true)}}
              href={`/admin/users`}
              className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 3 && 'bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto">
                <i className="fa-solid fa-users items-center text-xl"></i><br/>
                Users
              </span>
            </Link>


            <div className="text-gray-500 text-center my-4">-</div>

            <Link 
              onClick={()=>{setCurrentNavId(4); setLoading(true)}}
              href={`/admin/jobs`}
              className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 4 && 'bg-gray-200 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto"><i className="fa-regular fa-folder-open items-center text-xl"></i><br/>
              Jobs
              </span>
            </Link>

            <Link 
            onClick={()=>{setCurrentNavId(5); setLoading(true)}}
            href={`/admin/talents`}
            className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 5 && 'bg-gray-200 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto"><i className="fa-solid fa-people-group text-xl"></i><br/>
              Talent
              </span>
            </Link>



            {/* <div className="text-gray-500 text-center my-4">-</div> */}

            <Link 
              href="#" 
              onClick={()=>{callback({jobModalOpen:true})}}
              className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 2 && 'hover:bg-gray-200 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto"><i className="fa-solid fa-file-circle-plus text-xl"></i><br/>
              New Job
              </span>
            </Link>

            <Link 
              href="#" 
              onClick={()=>{callback({talentModalOpen:true})}}
              className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 py-2`}>
              <span className="text-center mx-auto"><i className="fa-solid fa-person-circle-plus text-xl"></i><br/>
              New Talent
              </span>
            </Link>









          

            {/* <div className="text-gray-500 text-center">----</div> */}

         


</div>



          
          </ul>


        {/* BOTTOM */}
        <div className="text-black dark:text-gray-200 mb-2">

        {/* <Link 
        onClick={()=>{callback({supportModalOpen: true})}}
        href={`#`}
        className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 9 && 'bg-gray-200 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-800'} py-2`}>
        <span className="text-center mx-auto"><i className="fa-solid fa-comment text-xl"></i><br/>{lang === 'fr' ? 'Support' : 'Support'}</span>
      </Link> */}


        <Link 
        onClick={()=>setCurrentNavId(10)}
        href={`/admin/root`}
        className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 10 && 'bg-gray-200 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-800'} py-2`}>
        <span className="text-center mx-auto"><i className="fa-solid fa-gear text-xl"></i><br/>{lang === 'fr' ? 'Réglages' : 'Settings'}</span>
      </Link>



        {/* <Link 
          href="/admin/root"
          className="transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded-lg m-1 dark:text-gray-200"
        >
          <li className="flex justify-center items-center py-2">
            <i className="fa-solid fa-cog"></i>
          </li>
        </Link> */}
</div>
        
      </div>
    </aside>



//       <aside
//       id="NavSidebar"
//       className="fixed top-0 left-0 z-30 w-20 h-screen transition-transform bg-white border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700"
//       aria-label="NavSidebar"
//     >
//       <div className="h-full bg-gray-200 dark:bg-gray-800 flex flex-col justify-between">

//         <div className="flex flex-col justify-center">

//         </div>



//         <ul className="space-y-2">



// <div>


//             <Link href="#" onClick = {()=>{callback({talentModalOpen: true})}}
//             className="cursor-pointer transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded m-1 dark:text-gray-200 ">
//             <li className="flex p-2 text-xs">
//             {/* <i className="fa-solid fa-house"></i> */}
//             <span className="text-pink-600 mr-1">+</span>Talent
//             </li>
//           </Link>
          
//             <Link href="#" onClick = {()=>{callback({jobModalOpen: true})}}
//             className="cursor-pointer transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded m-1 dark:text-gray-200 ">
//             <li className="flex p-2 text-xs">
//               {/* <i className="fa-solid fa-user-group"></i> */}
//               <span className="text-pink-600 mr-1">+</span>Job
//             </li>
//           </Link>

//             <div className="text-gray-500 text-center">----</div>

//             <Link href="/admin/jobs"
//             className="cursor-pointer transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded m-1 dark:text-gray-200 ">
//             <li className="flex p-2 text-xs">
//             Jobs
//             </li>
//           </Link>


//           <Link href="/admin/jobs"
//             className="cursor-pointer transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded m-1 dark:text-gray-200 ">
//             <li className="flex p-2 text-xs">
//             Jobs
//             </li>
//           </Link>

//           <Link href="/admin/talents"
//             className="cursor-pointer transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded m-1 dark:text-gray-200 ">
//             <li className="flex p-2 text-xs">
//             Talents
//             </li>
//           </Link>

//           <Link href="#" onClick = {()=>{callback({tagsModalOpen: true})}}
//             className="cursor-pointer transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded m-1 dark:text-gray-200 ">
//             <li className="flex p-2 text-xs">
//             Tags
//             </li>
//           </Link>

//           {/* <Link href="#" onClick = {()=>{callback({bulletinModalOpen: true})}}
//             className="cursor-pointer transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded m-1 dark:text-gray-200 ">
//             <li className="flex p-2 text-xs">
//             Bulletins
//             </li>
//           </Link> */}

//           <Link href="/admin/reports"
//             className="cursor-pointer transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded m-1 dark:text-gray-200 ">
//             <li className="flex p-2 text-xs">
//             Reports
//             </li>
//           </Link>


// </div>



          
//           </ul>


//         {/* BOTTOM */}
//         <div>
//         <Link 
//           href="/admin/root"
//           className="transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded-lg m-1 dark:text-gray-200"
//         >
//           <li className="flex justify-center items-center py-2">
//             <i className="fa-solid fa-cog"></i>
//           </li>
//         </Link>
// </div>
        
//       </div>
//     </aside>

     )
}

export default AdminSideNavbar